import COMMON from './common';
import GOLDEN_PALETTES from './golden-palettes';
import TOLERANCE from './tolerance';

export default {
  COMMON,
  GOLDEN_PALETTES,
  TOLERANCE,
};
